// Route a remote CMS/CDN image through the server-side optimizer so large
// uploads (founder/topper photos) are served as small WebP at display size.
// Relative/static assets and tiny generated avatars pass through untouched.
export function optimg(url, w = 640, q = 72) {
  if (!url || typeof url !== "string") return url;
  if (!/^https?:\/\//i.test(url)) return url;      // relative/static — already optimized
  if (/ui-avatars\.com/i.test(url)) return url;    // tiny generated avatar, no gain
  const API = process.env.REACT_APP_BACKEND_URL || "";
  return `${API}/api/site/image?src=${encodeURIComponent(url)}&w=${w}&q=${q}`;
}
